import StyledAccordion, { AccordionSummary, AccordionDetails } from "@/components/StyledAccordion/StyledAccordion";
import { Avatar, List } from "@/components/ui";
import { ChevronDown } from "lucide-react";
import { IEdoQuizAttempt } from "@/shared/model/edo-quiz-attempt.model";
import { IUser } from "@/shared/model/user.model";
import axios from "axios";
import { useEffect, useState } from "react";
import { Translate } from "react-jhipster";
import AttemptRow from "./AttemptRow";

interface UserQuizAttemptsAccordionProps {
  user: IUser;
  courseQuizId: number;
  onOpenAttempt?: (quizAttempt: IEdoQuizAttempt) => void;
}

const UserQuizAttemptsAccordion = (props: UserQuizAttemptsAccordionProps) => {
  const [quizAttempts, setQuizAttempts] = useState<IEdoQuizAttempt[]>([]);
  const { user, courseQuizId, onOpenAttempt: handleOpenAttempt } = props;

  useEffect(() => {
    const getUserQuizAttempts = async () => {
      const response = await axios.get<{ data: IEdoQuizAttempt[] }>(
        `/course-quizzes/${courseQuizId}/users/${user.id}/attempts`
      );
      setQuizAttempts(response.data.data);
    };
    if (user?.id) getUserQuizAttempts();
  }, [user?.id, courseQuizId]);

  return (
    <StyledAccordion>
      <AccordionSummary
        expandIcon={
          <ChevronDown
            className={`accordion-chevron h-4 w-4 shrink-0 transition-transform duration-200 ${!quizAttempts.length ? "text-primary" : "text-[var(--color-mockup-text-light)]"}`}
          />
        }
      >
        <div className="flex min-w-0 items-center gap-3">
          <Avatar
            alt={`${user.firstName} ${user.lastName}`}
            fallback={`${user.firstName?.[0] ?? ""}${user.lastName?.[0] ?? "?"}`}
          />
          <p className="truncate text-body font-medium text-[var(--color-mockup-text)]">
            {user.firstName} {user.lastName}
          </p>
        </div>
      </AccordionSummary>
      <AccordionDetails className="p-0">
        <List className="border-0">
          {quizAttempts?.length ? (
            quizAttempts.map((quizAttempt) => (
              <AttemptRow
                key={quizAttempt.id}
                quizAttempt={quizAttempt}
                onOpen={handleOpenAttempt!}
              />
            ))
          ) : (
            <p className="px-4 py-3 text-body text-[var(--color-mockup-text-light)]">
              <Translate contentKey="edocendoApp.edoQuizAttempt.home.notFound" />
            </p>
          )}
        </List>
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default UserQuizAttemptsAccordion;
